import React from 'react';
import Container from 'react-bootstrap/Container';

const Main = () => {
  return (
    <>
    <div className='about-sec-bg-banner'>
        <Container >
            <div className='aboutus-sec-text-div'>
            <h1 className='aboutus-sec-text'>ABOUT US</h1>
            </div>
        </Container>
    </div>
    </>
  );
};

export default Main